<template>
  <span>
    {{ value }}
  </span>
</template>

<script>
export default {
  name: 'RecruiterIcoCriteriaResultTypeDefault',
  props: {
    jobQuestion: {
      type: Object,
      required: true,
    },
  },
  computed: {
    value: function () {
      return (this.jobQuestion && this.jobQuestion.value) || '';
    },
  },
};
</script>

<style scoped />
